import type { FerryIngredient } from '@apps/main/modules/recipe/ingredients';
import type { FerryIngredientFilters } from '@apps/main/modules/recipe/ingredients/ferryIngredient';

import { TransportVehicleType } from '@libs/trip-planner-interfaces';

import { TRANSPORT_FILTERS_SEPARATOR } from '../constants';
import {
  serializePorts,
  serializeTransportIds,
  serializeTransportFilters,
  serializeAvailabilityOrder,
} from '../serializeTransport';

import { FERRY_INGREDIENT_SUFFIX } from './constants';

export function serializeFerry(ferry: FerryIngredient): string {
  let result = serializePorts(ferry);

  result += serializeTransportIds(ferry.transportIds);

  result += serializeFerryFilters(ferry.filters);

  result += serializeFerryVehicles(ferry.vehicles);

  result += serializeAvailabilityOrder(ferry);

  result += FERRY_INGREDIENT_SUFFIX;

  return result;
}

function serializeFerryFilters(filters: FerryIngredientFilters): string {
  return serializeTransportFilters(filters).join(TRANSPORT_FILTERS_SEPARATOR);
}

function serializeFerryVehicles(vehicles: TransportVehicleType[] = []): string {
  const serializedVehicles = vehicles
    .map((vehicle) => (vehicle === TransportVehicleType.None ? '' : vehicle))
    .join(TRANSPORT_FILTERS_SEPARATOR);

  return `${TRANSPORT_FILTERS_SEPARATOR}${serializedVehicles}`;
}
